export const STORAGE_KEY = {
    AUTH_DATA: 'app-auth',
    TOKEN_EXPIRE: 'token_expire',
    POWERBI: 'powerbi',
  };